import {HTTP} from "@shared/_helpers/http";

export default class OrderApi {
    static fetchOrderList(customerShopId, articleId) {
        return HTTP.get(`/private/order/${customerShopId}/${articleId ? articleId : ''}`)
            .then(response => response.data)
    }
}